<template>
  <div class="checkin-time-restriction text-center">
    <svg
      class="restriction-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.6"
    >
      <circle cx="12" cy="12" r="9"></circle>
      <path d="M12 7v5l3.2 2" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
    <p class="restriction-heading">{{ $t('touch-down.checkin_time_restriction_title') }}</p>
    <p class="restriction-range">{{ fromTime }}&nbsp;-&nbsp;{{ toTime }}</p>
    <p class="restriction-note">{{ $t('touch-down.checkin_time_restriction_note') }}</p>
    <button v-if="!closeAttempted" type="button" class="btn restriction-close" @click="close">
      <span class="fa fa-times mr-1" aria-hidden="true"></span>{{ $t('touch-down.close') }}
    </button>
    <p v-else class="restriction-note">{{ $t('touch-down.checkin_time_restriction_close_note') }}</p>
  </div>
</template>

<script>
export default {
  name: 'CheckinTimeRestriction',
  props: {
    fromTime: {
      type: String,
      default: '',
    },
    toTime: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      closeAttempted: false,
    };
  },
  methods: {
    close() {
      this.$emit('close');
      window.close();
      // Browsers only allow scripts to close tabs/windows they opened themselves,
      // so if we're still here, the guest needs to close it manually.
      this.closeAttempted = true;
    },
  },
};
</script>

<style scoped>
.checkin-time-restriction {
  padding: 0.5rem 0 0.25rem;
}

.restriction-icon {
  width: 34px;
  height: 34px;
  color: #1a5dab;
  margin-bottom: 0.5rem;
}

.restriction-heading {
  font-weight: 700;
  font-size: 1.05rem;
  color: #22262b;
  margin-bottom: 0.5rem;
}

.restriction-range {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a5dab;
  margin-bottom: 0.4rem;
}

.restriction-note {
  font-size: 0.85rem;
  color: #6b6f76;
  margin-bottom: 1.4rem;
}

.restriction-close {
  border: 1px solid #bcdff0;
  background: #eef9fd;
  color: #1a5dab;
  border-radius: 4px;
  padding: 0.5rem 1.8rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.restriction-close:hover {
  background: #dff0f9;
}
</style>
